import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './SVG';
import Navigation from './Navigation';
import LanguageForm from "../form/LanguageForm";

class Header extends Component{

	constructor(){
		super();

		this.state = {
			mainNav: 'main-nav',
			mainNavMobile: 'main-nav-mobile',
			mainNavButton: 'main-nav-button',
			openMainNavMobile: true
		};
	}

	mobileNavigationHandler = (e) => {
		e.preventDefault();
		const openMainNavMobile = !this.state.openMainNavMobile;
		const mainNavMobile = openMainNavMobile ? 'main-nav-mobile' : 'main-nav-mobile main-nav-mobile--open' ;
		const mainNavButton = openMainNavMobile ? 'main-nav-button' : 'main-nav-button main-nav-button--open';


		this.setState({
			mainNavMobile,
			mainNavButton,
			openMainNavMobile
		});
	};

	render(){
		const {mainNav,localizePath} = this.props;
		return (
			<header className="main-header">
				<div className="main-header__navbar">
					<div className="container-flex">
						<h1 className="amiko-logo">
							<Link to={localizePath('/')}>
								<Logo/>
							</Link>
						</h1>
						<Navigation
							navClassName={this.state.mainNav}
							type="desktop"
							items={mainNav.items}
							localizePath={localizePath}
						/>
						<button className={this.state.mainNavButton} onClick={this.mobileNavigationHandler}>
							<span className="main-nav-button__line" />
						</button>
						<Navigation
							navClassName={this.state.mainNavMobile}
							type="mobile"
							items={mainNav.items}
							localizePath={localizePath}
						/>
						<LanguageForm { ...this.props }/>
					</div>
				</div>
			</header>
		);
	}
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/common/Header.js